import { Definition as CemCalloutDefinition } from './cem-callout';
import { Definition as CemPopupDefinition } from './cem-popup';

/**
 * Managed nudges are those that are controlled by the Central Engagement Management (CEM) system.
 */
export const definitions = Object.freeze(Array.from(new Set([CemCalloutDefinition, CemPopupDefinition])));